<template>
  <div class="ti-me-vehicle-chooser">
    <template v-if="loggedIn">
      <template v-if="userAssociatedVehicles.length > 0">
        <div class="ti-me-vehicle-chooser__header">
          <div class="ti-me-vehicle-chooser__header-text">
            <h2>
              <I18n :path="$t('i18n.meSearch.vehicleChooser.fullNameHeadline')">
                <template v-slot:fullName>
                  <span>{{ fullName }}</span>
                </template>
              </I18n>
            </h2>

            <p>
              {{
                userAssociatedVehicles.length === 1
                  ? $t('i18n.meSearch.vehicleChooser.single.copy')
                  : $t('i18n.meSearch.vehicleChooser.copy')
              }}
            </p>
          </div>
        </div>

        <div class="ti-me-vehicle-chooser__vehicles">
          <MEVehicleRadioCard
            v-for="vehicle of userAssociatedVehicles"
            :key="vehicle.finOrVin"
            :name="vehicle.modelDescription"
            :value="vehicle.finOrVin"
            :imageUrl="get16x9croppedImageProxySrc(vehicle.imageUrl, '690')"
            :selectedValue="selectedVehicle"
            @selectedValueChanged="chooseVehicle(vehicle)"
          >
            <template v-slot:infos>
              <h3>{{ vehicle.modelDescription }}</h3>
              <span>{{
                $t('i18n.meSearch.vehicleChooser.choiceDescriptionPrefix') +
                ' ' +
                vehicle.finOrVin
              }}</span>
            </template>
          </MEVehicleRadioCard>
        </div>

        <TooltipComponent :text="$t('i18n.meSearch.vehicleChooser.tooltip')" />
      </template>

      <template v-else>
        <div class="ti-me-vehicle-chooser__header">
          <div class="ti-me-vehicle-chooser__header-text">
            <h2>{{ $t('i18n.meSearch.noVehiclesFound.headline') }}</h2>
            <p>{{ $t('i18n.meSearch.noVehiclesFound.copy') }}</p>
          </div>
        </div>
      </template>
    </template>

    <template v-else>
      <MeLoginComponent class="ti-me-vehicle-chooser__login-button" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { Ref, ref, watch, onMounted } from 'vue';
import { UserAssociatedVehicles } from '@owc/connection-wko-manager';
import { get16x9croppedImageProxySrc } from '@tradein/utils';
import MeLoginComponent from '../me-login/me-login.vue';
import MEVehicleRadioCard from '../form-element/components/radio-card.vue';
import TooltipComponent from '../tooltip/tooltip.vue';
import I18n from '../i18n/i18n.vue';

import setup from '../../composables/setup';

interface Props {
  userSelectedVehicle?: string;
}

const props = defineProps<Props>();
const { wellKnownObjects, userProfile, loggedIn } = setup();
const emit = defineEmits(['selectedVehicle']);
const userAssociatedVehicles: Ref<UserAssociatedVehicles[]> = ref([]);
const fullName = ref('' as string | undefined);
const selectedVehicle = ref('');

onMounted(() => {
  if (props.userSelectedVehicle && props.userSelectedVehicle.length > 0) {
    selectedVehicle.value = props.userSelectedVehicle;
  }
});

watch(
  () => wellKnownObjects.value,
  (wko) => {
    userAssociatedVehicles.value =
      wellKnownObjects.value?.User?.associatedVehicles ?? [];
    fullName.value = userProfile.value?.lastName1;
  },
  { immediate: true },
);

const chooseVehicle = (vehicle: UserAssociatedVehicles): void => {
  selectedVehicle.value = vehicle.finOrVin;
  emit('selectedVehicle', vehicle);
};
</script>
<style lang="scss" src="./me-vehicle-chooser.scss"></style>
